const AI_API_URL = (
  process.env.REACT_APP_AI_API_URL ||
  "https://qualionai.iiiqbets.com"
).replace(/\/+$/, "");

export async function sendAIMessage(message, conversationId = null) {
  try {
    const response = await fetch(`${AI_API_URL}/api/v1/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message,
        conversation_id: conversationId,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();

      throw new Error(
        `AI service error (${response.status}): ${
          errorText || response.statusText
        }`
      );
    }

    return await response.json();
  } catch (error) {
    console.error("AI Assistant request failed:", error);

    if (error instanceof TypeError) {
      throw new Error(
        "Unable to contact the AI service. Check the AI server URL, network connection, and server status."
      );
    }

    throw error;
  }
}